<template>
  <div class="pdf-upload-container mb-4">
    <div 
      class="dropzone"
      :class="{ 'dragover': isDragOver, 'uploading': isUploading }"
      @drop="handleDrop"
      @dragover.prevent="handleDragOver"
      @dragleave="handleDragLeave"
      @click="triggerFileInput"
    >
      <input 
        ref="fileInput"
        type="file" 
        accept=".pdf"
        multiple
        style="display: none"
        @change="handleFileSelect"
      />
      
      <div v-if="!isUploading" class="upload-content">
        <i class="bi bi-cloud-upload fs-1 text-primary mb-2"></i>
        <p class="mb-2"><strong>Sleep PDF Orders hierheen</strong></p>
        <p class="text-muted mb-2">of <span>klik om bestanden te selecteren</span></p>
        <small class="text-muted">Ondersteunde formaten: PDF (meerdere bestanden mogelijk)</small>
      </div>
      
      <div v-else class="upload-content">
        <div class="spinner-border text-primary mb-2" role="status">
          <span class="visually-hidden">Uploading...</span>
        </div>
        <p class="mb-0">Uploaden...</p>
        <small class="text-muted">{{ uploadProgress }}</small>
      </div>
    </div>
  </div>
</template>

<script>
import ServiceFactory from '../services/ServiceFactory'

export default {
  name: 'PdfUploadDropzone',
  data() {
    return {
      isDragOver: false,
      isUploading: false,
      uploadProgress: '',
      pdfParsingService: null
    }
  },

  mounted() {
    this.pdfParsingService = ServiceFactory.getService('PdfParsingService');

    // Listen to service events
    this.pdfParsingService.addEventListener('pdfQueued', this.handlePdfQueuedEvent);
    this.pdfParsingService.addEventListener('pdfParsingFailed', this.handlePdfFailedEvent);
    this.pdfParsingService.addEventListener('pdfUploadProgress', this.handleProgressEvent);
    this.pdfParsingService.addEventListener('pdfUploadCompleted', this.handleCompletedEvent);
  },

  beforeUnmount() {
    // Cleanup event listeners
    if (this.pdfParsingService) {
      this.pdfParsingService.removeEventListener('pdfQueued', this.handlePdfQueuedEvent);
      this.pdfParsingService.removeEventListener('pdfParsingFailed', this.handlePdfFailedEvent);
      this.pdfParsingService.removeEventListener('pdfUploadProgress', this.handleProgressEvent);
      this.pdfParsingService.removeEventListener('pdfUploadCompleted', this.handleCompletedEvent);
    }
  },
  methods: {
    handleDragOver(e) {
      e.preventDefault()
      this.isDragOver = true
    },
    
    handleDragLeave() {
      this.isDragOver = false
    },
    
    handleDrop(e) {
      e.preventDefault()
      this.isDragOver = false
      const files = Array.from(e.dataTransfer.files).filter(file => file.type === 'application/pdf')
      if (files.length > 0) {
        this.uploadFiles(files)
      } else {
        this.$emit('showToast', ['Alleen PDF bestanden zijn toegestaan', 'bg-warning'])
      }
    },
    
    triggerFileInput() {
      if (!this.isUploading) {
        this.$refs.fileInput.click()
      }
    },
    
    handleFileSelect(e) {
      const files = Array.from(e.target.files)
      if (files.length > 0) {
        this.uploadFiles(files)
      }
    },
    
    async uploadFiles(files) {
      this.isUploading = true;

      // Clear file input
      this.$refs.fileInput.value = '';

      // Upload de bestanden naar de wachtrij (parser mode is configured on backend)
      await this.pdfParsingService.uploadMultiplePdfs(files);

      this.isUploading = false;
      this.uploadProgress = '';
    },

    handlePdfQueuedEvent(event) {
      const { filename, data } = event.detail;
      this.$emit('pdfQueued', { filename, data });
    },

    handlePdfFailedEvent(event) {
      console.error('PDF upload failed:', event.detail);
    },

    handleProgressEvent(event) {
      const { current, total, filename } = event.detail;
      this.uploadProgress = `Uploaden van ${filename} (${current}/${total})`;
    },

    handleCompletedEvent(event) {
      const { successCount, errorCount } = event.detail;

      // Show success/error toast
      if (successCount > 0 && errorCount === 0) {
        this.$emit('showToast', [`${successCount} PDF bestand(en) in wachtrij geplaatst`, 'bg-success']);
      } else if (successCount > 0 && errorCount > 0) {
        this.$emit('showToast', [`${successCount} in wachtrij, ${errorCount} gefaald`, 'bg-warning']);
      } else {
        this.$emit('showToast', [`Alle ${errorCount} uploads gefaald`, 'bg-danger']);
      }
    }
  }
}
</script>

<style scoped>
.pdf-upload-container {
  max-width: 100%;
}

.dropzone {
  border: 2px dashed #dee2e6;
  border-radius: 8px;
  padding: 2rem;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
  background-color: #f8f9fa;
}

.dropzone:hover {
  border-color: #0d6efd;
  background-color: #e7f1ff;
}

.dropzone.dragover {
  border-color: #0d6efd;
  background-color: #e7f1ff;
  transform: scale(1.02);
}

.dropzone.uploading {
  cursor: not-allowed;
  opacity: 0.7;
}

.upload-content {
  pointer-events: none;
}

.upload-results {
  max-height: 300px;
  overflow-y: auto;
}

.modal.show {
  display: block !important;
}

pre {
  max-height: 400px;
  overflow-y: auto;
  font-size: 0.875rem;
}
</style>
